import React from 'react';
import PropTypes from 'prop-types';

import Link, { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import Button from '../../../01_atoms/Button';
import Chevron from '../../../../public/static/icons/navigation-chevron-down.svg';
import FormattedText from '../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

class BBStepper extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      expandedStep: 0,
    };

    this.expandStep = this.expandStep.bind(this);
  }

  expandStep(step) {
    this.setState((state) => ({
      expandedStep: state.expandedStep === step ? -1 : step,
    }));
  }

  getStepperAlt(index, hasTickMarks) {
    const alts = {
      1: 'One',
      2: 'Two',
      3: 'Three',
    };
    return hasTickMarks ? '' : alts[index + 1];
  }

  render() {
    const { title, steps, hasTickMarks, behaviorSettings, uuid } = this.props;
    const { expandedStep } = this.state;

    const classes = [
      'bb',
      'bb-stepper',
      styles['bb-stepper'],
      generateClassNameByBehaviorSettings(behaviorSettings),
    ];

    return (
      <div className={classes.join(' ')} id={uuid}>
        <div className="container">
          {title && <h2>{title}</h2>}

          <div className="row">
            {steps.map((step, index) => (
              <div className="col-md-4" key={step.title}>
                <div
                  className={`step ${expandedStep === index ? 'active' : ''}`}
                  onClick={() => this.expandStep(index)}
                  onKeyPress={() => this.expandStep(index)}
                >
                  <img
                    src={`/static/icons/${
                      hasTickMarks ? 'tick.svg' : `large-number-${index + 1}@3x.svg`
                    }`}
                    className="step-icon"
                    width={40}
                    height={40}
                    alt={this.getStepperAlt(index, hasTickMarks)}
                  />

                  <div
                    className={`toggler d-md-none ${expandedStep === index ? 'opened' : 'closed'}`}
                  >
                    <Chevron />
                  </div>

                  {step.title && (
                    <p className="title">
                      <strong>{step.title}</strong>
                    </p>
                  )}

                  <div className={`content ${expandedStep === index ? 'visible' : 'hidden'}`}>
                    {step.content && <FormattedText className="text" text={step.content} />}

                    {step.button && step.button.label && step.button.nextLink && (
                      <Link {...step.button.nextLink}>
                        <Button
                          tag="a"
                          href={step.button.nextLink.url}
                          type="secondary"
                          isOutlined
                          isMobileBlock
                          className="bb-stepper--button"
                        >
                          {step.button.label}
                        </Button>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

BBStepper.propTypes = {
  title: PropTypes.string,
  hasTickMarks: PropTypes.bool,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
      button: PropTypes.shape({
        label: PropTypes.string,
        nextLink: PropTypes.shape(linkPropTypes),
      }),
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

BBStepper.defaultProps = {
  title: '',
  hasTickMarks: false,
  behaviorSettings: null,
  uuid: null,
};

export default BBStepper;
